/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.parcoursStand.ts
 *
 * « Parcours guidé » de Mon stand (2026-10-07, demande de Mika) : un écran
 * par fonction de l'espace, dans la voix de Mika qui s'adresse à ceux qui
 * tiennent un stand ou animent une activité. Vouvoiement, phrases simples,
 * aucun nom d'événement (jetons d'identité et de lexique). Fusionné dans
 * fr.ts. Mikael - chef de projet - 2026-10-07
 */
export const messagesParcoursStandFr: Record<string, string> = {
  'parcoursStand.bouton': 'Parcours guidé',
  'parcoursStand.dialogue': 'Parcours guidé de votre espace',
  'parcoursStand.fermer': 'Fermer le parcours guidé',
  'parcoursStand.precedent': 'Précédent',
  'parcoursStand.suivant': 'Suivant',
  'parcoursStand.terminer': 'Terminer',
  'parcoursStand.yAller': 'Y aller',
  'parcoursStand.position': '{n} / {total}',
  'parcoursStand.plus.lien': 'Mon stand',

  'parcoursStand.accueil.titre': 'Votre espace, en un coup d’œil',
  'parcoursStand.accueil.texte':
    'Tout ce qui vous sert avant, pendant et après {eventTypeDef} est réuni ici. Les chiffres de votre stand se mettent à jour seuls, sans recharger la page.',
  'parcoursStand.fiche.titre': 'Votre fiche et vos postes',
  'parcoursStand.fiche.texte':
    'Présentez votre structure, ajoutez votre logo et publiez vos postes à pourvoir. Les visiteurs les consultent avant de venir : une fiche complète vous amène des candidats déjà intéressés.',
  'parcoursStand.ateliers.titre': 'Vos {lexWorkshopPlural}',
  'parcoursStand.ateliers.texte':
    'Créez vos {lexWorkshopPlural}, choisissez le créneau et le nombre de places. Tant qu’un brouillon n’est pas publié, personne ne le voit : « Publier maintenant » le rend visible et ouvre les inscriptions.',
  'parcoursStand.scanner.titre': 'La douchette',
  'parcoursStand.scanner.texte':
    'Le jour J, visez le badge d’un visiteur avec l’appareil photo : son contact s’enregistre aussitôt. Vous pouvez ajouter des étoiles et une note pour vous souvenir de l’échange, même sans réseau.',
  'parcoursStand.controle.titre': 'Le contrôle d’accès',
  'parcoursStand.controle.texte':
    'Le jour J, scannez le badge des participants à l’entrée de {lexWorkshopDef} : l’écran vous dit tout de suite si la personne est inscrite.',
  'parcoursStand.decouverte.titre': 'Le mode découverte',
  'parcoursStand.decouverte.texte':
    'Avant le jour J, entraînez-vous avec des badges de test : affichez-les à l’écran ou imprimez-les, puis scannez-les. Rien n’est enregistré, c’est fait pour essayer.',
  'parcoursStand.rencontres.titre': 'Vos fiches d’entretien',
  'parcoursStand.rencontres.texte':
    'Chaque personne scannée a sa fiche : vos notes, votre appréciation, la suite à donner. Retrouvez-les ici après {eventTypeDef}, pour rappeler les bons profils.',
  'parcoursStand.cv.titre': 'Les CV reçus',
  'parcoursStand.cv.texte':
    'Les candidats qui vous ont transmis leur CV apparaissent ici. Vous les lisez directement dans l’application, sans rien télécharger.',
  'parcoursStand.premium.titre': 'Le CV Matching',
  'parcoursStand.premium.texte':
    'Avec l’offre premium, recherchez dans les CV déposés les profils qui correspondent à vos postes, et proposez un entretien aux candidats retenus.',
  'parcoursStand.journal.titre': 'La chronologie',
  'parcoursStand.journal.texte':
    'Tout ce qui s’est passé sur votre stand, dans l’ordre : scans, CV reçus, entretiens. Pratique pour reprendre le fil en fin de journée.',
  'parcoursStand.journee.titre': 'Ma journée',
  'parcoursStand.journee.texte':
    'Le bilan de votre journée : nombre de contacts, profils rencontrés, moments forts. Vous pouvez aussi exporter vos scans pour les retravailler.',
  'parcoursStand.recruteurs.titre': 'Vos recruteurs',
  'parcoursStand.recruteurs.texte':
    'Ajoutez les collègues qui tiennent le stand avec vous : chacun reçoit son accès et scanne avec son propre téléphone, tout arrive au même endroit.',
  'parcoursStand.badge.titre': 'Votre badge',
  'parcoursStand.badge.texte':
    'Votre badge est dans l’application : montrez-le à l’entrée, ou imprimez-le avant de venir.',
  'parcoursStand.guide.titre': 'Votre guide',
  'parcoursStand.guide.texte':
    'Un guide pas à pas, fait pour vous, reprend tout cela en détail. Gardez-le sous la main le jour J.',
  'parcoursStand.wifi.titre': 'Le Wi-Fi',
  'parcoursStand.wifi.texte':
    'Le nom du réseau et son mot de passe sont dans « Plus », puis « Wi-Fi ». Un code QR permet de connecter un second téléphone en un geste.',
};
